<template>
  <v-chip
    v-bind="$attrs"
    label
    :class="{ 'text-white': isDarkChip(propertyType) }"
    size="small"
    :color="getPropertyTypeColor(propertyType)"
  >
    {{ propertyType }}
  </v-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { getPropertyTypeColor } from '@/bundles/Property/helpers/colors/getPropertyTypeColor';
import { PropertyTypeEnum } from '@/bundles/Property/interfaces/PropertyType';

export default defineComponent({
  name: 'PropertyTypeChip',

  props: {
    propertyType: {
      type: String,
      required: true
    },
  },

  methods: {
    getPropertyTypeColor,
    isDarkChip (propertyType: PropertyTypeEnum) {
      return propertyType !== PropertyTypeEnum.retail;
    }
  }
});
</script>
